import React from "react";
import Benefits from "./Benefits";

function About() {
  return (
    <div>
      <Benefits />
    </div>
  );
}

export default About;
